import React, { useState, useRef, useEffect } from 'react';

const VideoThumbnail = ({ videoUrl, title, description, className }) => {
  const videoRef = useRef(null);

  return (
    <div className={`relative ${className}`}>
      {/* Video element - first frame shows as thumbnail */}
      <video
        ref={videoRef}
        src={videoUrl}
        className="w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      />
    </div>
  );
};

export default VideoThumbnail;